export default __webpack_public_path__ + "static/media/sticker-c.55336386.png";